import React from 'react';
import AboutBackground from '../assets/about-background.png';
import AboutBackgroundImage from '../assets/about-background-image.png';
import { BsFillPlayCircleFill } from 'react-icons/bs';

const About = () => {
  return (
    <div className='about-section-container' id="aboutus">
      <div className='about-background-image-container'>
        <img src={AboutBackground} alt="About Us Image"/>
      </div>
      <div className='about-section-image-container'>
        <img src={AboutBackgroundImage} />
      </div>
      <div className='about-section-text-container'>
        <p className='primary-subheading'>About</p>
        <h1 className='primary-heading'>
            Good Food Brings People Together
        </h1>
        <p className='primary-text'>
            CraveOn delivers fresh, delicious meals from your favorite restaurants—hot, fast, and right to your doorstep.
        </p>
        <p className='primary-text'>
            From everyday meals to special treats, CraveOn makes food delivery quick, easy, and satisfying.
        </p>
        <div className='about-buttons-container'>
            <button className='secondary-button'>Learn More</button>
            <button className='watch-video-button'>
                <BsFillPlayCircleFill /> Watch Video
            </button>
        </div>
      </div>
    </div>
  )
}

export default About
